'use client'
var version = "4.4.3";
var dependencies = {
	"@dynamic-labs/sdk-api-core": "0.0.599",
	"@hcaptcha/react-hcaptcha": "1.4.4",
	"@thumbmarkjs/thumbmarkjs": "0.16.0",
	"country-list": "2.3.0",
	formik: "2.2.9",
	i18next: "23.4.6",
	qrcode: "1.5.1",
	"react-focus-lock": "2.9.2",
	"react-i18next": "13.5.0",
	yup: "0.32.11",
	"react-international-phone": "4.2.5"
};

export { dependencies, version };
